import store from '@/store'
import { cancelHTTPRequests } from '@/services/utils'
import http from './webhook/httpconfig'
import { getCookie } from './cookie'
import { isAuthTokenPresent } from './utils'
import { cookieConstant } from './constants'
import { checkErrorFromSocial } from './utils'
import API_ERRORS from './constants/api-error'
import { getCdnBaseUrl } from './utils' 

async function transcriptHistory() {
  try {
    const { getBotRefId, getEmailId } = store?.getters || {}
    const payload = {
      botRefId: getBotRefId,
      conversationId: getCookie(cookieConstant.SESSION.CONVERSATION_ID),
      mail: getEmailId,
      from: store?.state?.widgetConfig?.sendTranscriptEmailSetup?.email
    }

    const result = await http.request({
      method: 'post',
      url: '/api/sendTranscript',
      data: payload,
      headers: { ...generateHeaders() },
      cancelToken: cancelHTTPRequests()
    })
    return result
  } catch (error) {
    const customSocialError = checkErrorFromSocial(error?.response)
    customSocialError.customMessage = API_ERRORS.TRANSCRIPT_HISTORY
    throw customSocialError
  }
}

const generateHeaders = (additionalHeaders = []) => {
  const { getBotRefId, getWidgetId, getUserId } = store?.getters || {}
  const headers = {
    'Content-Type': 'application/json',
    'x-bot-ref-id': getBotRefId,
    'x-conversation-id': getCookie(cookieConstant.SESSION.CONVERSATION_ID),
    'x-widget-id': getWidgetId,
    'x-user-id': getUserId,
    'x-cdn-url': getCdnBaseUrl()
  }
  const isAuthenticationEnabled =
    store.state.widgetConfig?.isAuthenticationEnabled || false
  addCustomHeader('x-auth-enabled', isAuthenticationEnabled, headers)

  if (isAuthenticationEnabled && isAuthTokenPresent()) {
    addCustomHeader(
      'x-auth-token',
      store?.state?.authToken || getCookie(cookieConstant.AUTH.AUTH_TOKEN),
      headers
    )
  }

  additionalHeaders.forEach(header =>
    addCustomHeader(header.key, header.value, headers)
  )
  return headers
}

const addCustomHeader = (key, value, headers) => {
  headers[key] = value
}

export { transcriptHistory }
